import React from "react";
import { NavLink } from "react-router-dom";
import { projects } from "../../data";

const ProjectsSection = () => {
  return (
    <div className="max-w-screen-xl text-center md:py-[60px] py-10 ">
      <p className="md:text-2xl text-lg md:mb-10 px-5 xl:px-0">
        Explore stunning photos showcasing the transformative power of Clear
        Choice cleaning services. See the remarkable difference we can make!
      </p>

      <div className="flex flex-wrap justify-between gap-10 w-full pt-10 pb-[80px] px-5 xl:px-0">
        {projects.map((item, index) => (
          <NavLink
            className="flex flex-col gap-3 text-left md:w-[48%] w-full"
            key={index}
            to={item.id}
          >
            <img
              src={item?.image ?? item.images[0]}
              alt={item.title}
              className="w-full h-[376px] object-cover rounded-md object-top"
            />
            <p className="text-lg font-medium">{item.title}</p>
            <p className="text-md ">{item.descrption}</p>
            <div className="flex justify-between">
              <p className="text-sm px-3 py-1 border-black border-2 rounded-3xl">
                {item.service}
              </p>
              <p className="text-blue-5 font-bold uppercase mr-5">
                Read More {">>>"}
              </p>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default ProjectsSection;
